<template>
   <v-layout align-start>
      <v-flex xs12>
         <!-- DIALOG CREAR / EDITAR  -->
         <v-dialog v-model="dialogCreateEdit" persistent max-width="500px">
            <v-form
               ref="formAranceles"
               v-model="validAranceles"
               lazy-validation
            >
               <v-card>
                  <v-card-text class="text--primary" style="margin-top: -20px">
                     <v-container grid-list-md>
                        <v-layout wrap>
                           <v-flex xs12>
                              <span class="text-h5 font-weight-medium">{{
                                 formTitle
                              }}</span>
                           </v-flex>
                        </v-layout>
                        <v-layout wrap>
                           <v-flex xs12 sm3>
                              <!-- Se completa mientras se escribe, en cuanto hay
                                   un NN-NNN-N: el sufijo tecleado acota la
                                   búsqueda a esa familia, y con el 4 se completa
                                   a 46 si el último 4x fue el 03-015-45. Lo
                                   añadido queda seleccionado, así que seguir
                                   escribiendo lo reemplaza en vez de pegársele. -->
                              <v-text-field
                                 ref="txtCodigo"
                                 v-model="codigo"
                                 :readonly="editedIndex != -1"
                                 :disabled="editedIndex != -1"
                                 :rules="rulesCodigo"
                                 :hint="hintCodigo"
                                 persistent-hint
                                 color="primary"
                                 label="Código"
                                 @keydown="registrarTeclaCodigo"
                              ></v-text-field>
                           </v-flex>
                           <v-flex xs12 sm9>
                              <v-text-field
                                 v-model="nombre"
                                 color="primary"
                                 label="Nombre"
                                 :rules="rulesNombre"
                              ></v-text-field>
                           </v-flex>
                           <v-flex xs12 sm6>
                              <v-text-field
                                 v-model="precio"
                                 color="primary"
                                 label="Precio"
                                 :rules="rulesPrecio"
                              ></v-text-field>
                           </v-flex>
                           <v-flex xs12 sm6>
                              <v-text-field
                                 v-model="comodin"
                                 color="primary"
                                 label="Comodín"
                              ></v-text-field>
                           </v-flex>
                           <v-flex xs12>
                              <v-autocomplete
                                 v-model="selectPublico"
                                 color="primary"
                                 item-value="id"
                                 item-text="descripcion"
                                 :items="cmbPublico"
                                 label="Público"
                              ></v-autocomplete>
                           </v-flex>
                           <v-flex xs12 sm4>
                              <v-switch
                                 v-model="aplicaBeca"
                                 color="primary"
                                 label="Aplica beca"
                              ></v-switch>
                           </v-flex>
                           <v-flex xs12 sm4>
                              <v-switch
                                 v-model="porCantidad"
                                 color="primary"
                                 label="Por cantidad"
                              ></v-switch>
                           </v-flex>
                           <v-flex xs12 sm4>
                              <v-switch
                                 v-model="requiereFacultad"
                                 color="primary"
                                 label="Req. facultad"
                              ></v-switch>
                           </v-flex>
                           <v-flex xs12 sm12>
                              <v-textarea
                                 v-model="descripcion"
                                 color="primary"
                                 rows="4"
                                 auto-grow
                                 outlined
                                 :rules="rulesDescripcion"
                                 label="Descripción"
                              ></v-textarea>
                           </v-flex>
                        </v-layout>
                     </v-container>
                  </v-card-text>

                  <v-card-actions
                     style="
                        margin-top: -20px;
                        margin-right: 20px;
                        padding-bottom: 20px;
                     "
                  >
                     <v-spacer></v-spacer>
                     <v-btn color="primary" text @click.native="close"
                        >Cancelar</v-btn
                     >
                     <v-btn
                        color="primary white--text"
                        :disabled="!validAranceles"
                        @click.native="save"
                        >Guardar</v-btn
                     >
                  </v-card-actions>
               </v-card>
            </v-form>
         </v-dialog>

         <v-card elevation="0">
            <v-toolbar color="primary" dark>
               <v-toolbar-title style="font-weight: 500"
                  >Aranceles</v-toolbar-title
               >
               <v-spacer></v-spacer>
               <v-text-field
                  ref="txtBusqueda"
                  v-model="search"
                  class="mt-3"
                  color="white"
                  append-icon="fa-search"
                  label="Búsqueda"
                  single-line
               ></v-text-field>
               <v-spacer></v-spacer>
               <v-btn text icon color="white darken-3" @click="nuevoArancel()">
                  <v-icon>fas fa-plus</v-icon>
               </v-btn>
            </v-toolbar>

            <!-- DATATABLE aranceles -->
            <v-data-table
               :headers="headers"
               :items="aranceles"
               :search="search"
               :footer-props="{
                  itemsPerPageOptions: [10, 25, 50],
                  itemsPerPageText: 'Filas por página:'
               }"
               no-results-text="Búsqueda sin resultados"
               class="elevation-1"
            >
               <template #item.publico="{ item }">
                  {{
                     item.publico == null
                        ? 'Ambos'
                        : item.publico
                        ? 'Externos'
                        : 'Alumnos'
                  }}
               </template>

               <template #item.aplicaBeca="{ item }">
                  <v-tooltip
                     v-if="item.aplicaBeca"
                     top
                     max-width="300"
                     color="primary"
                  >
                     <template #activator="{ on }">
                        <v-icon color="primary" v-on="on"
                           >fas fa-toggle-on</v-icon
                        >
                     </template>
                     <span style="font-size: 15px"> Si </span>
                  </v-tooltip>
                  <v-tooltip v-else top max-width="300" color="grey darken-1">
                     <template #activator="{ on }">
                        <v-icon color="grey" v-on="on"
                           >fas fa-toggle-off</v-icon
                        >
                     </template>
                     <span style="font-size: 15px"> No </span>
                  </v-tooltip>
               </template>

               <template #item.porCantidad="{ item }">
                  <v-tooltip
                     v-if="item.porCantidad"
                     top
                     max-width="300"
                     color="primary"
                  >
                     <template #activator="{ on }">
                        <v-icon color="primary" v-on="on"
                           >fas fa-toggle-on</v-icon
                        >
                     </template>
                     <span style="font-size: 15px"> Si </span>
                  </v-tooltip>
                  <v-tooltip v-else top max-width="300" color="grey darken-1">
                     <template #activator="{ on }">
                        <v-icon color="grey" v-on="on"
                           >fas fa-toggle-off</v-icon
                        >
                     </template>
                     <span style="font-size: 15px"> No </span>
                  </v-tooltip>
               </template>

               <template #item.requiereFacultad="{ item }">
                  <v-tooltip
                     v-if="item.requiereFacultad"
                     top
                     max-width="300"
                     color="primary"
                  >
                     <template #activator="{ on }">
                        <v-icon color="primary" v-on="on"
                           >fas fa-toggle-on</v-icon
                        >
                     </template>
                     <span style="font-size: 15px"> Si </span>
                  </v-tooltip>
                  <v-tooltip v-else top max-width="300" color="grey darken-1">
                     <template #activator="{ on }">
                        <v-icon color="grey" v-on="on"
                           >fas fa-toggle-off</v-icon
                        >
                     </template>
                     <span style="font-size: 15px"> No </span>
                  </v-tooltip>
               </template>

               <template #item.comodin="{ item }">
                  {{
                     item.comodin == null || item.publico == ''
                        ? 'N/A'
                        : item.comodin
                  }}
               </template>

               <template #item.opciones="{ item }">
                  <v-tooltip bottom color="primary">
                     <template #activator="{ on }">
                        <v-btn
                           text
                           small
                           fab
                           color="amber darken-3"
                           v-on="on"
                           @click="editItem(item)"
                        >
                           <v-icon>fa-pen</v-icon>
                        </v-btn>
                     </template>
                     <span>Editar</span>
                  </v-tooltip>
               </template>

               <!-- Si no hay datos, mostrar boton para listar de nuevo -->
               <template slot="no-data">
                  <div v-if="aranceles.length == 0">
                     <v-container>
                        <v-layout wrap align-center>
                           <v-flex xs12 class="text-center">
                              <v-btn color="primary" @click="reset"
                                 >Resetear</v-btn
                              >
                           </v-flex>
                        </v-layout>
                     </v-container>
                  </div>
               </template>
            </v-data-table>
         </v-card>
      </v-flex>
   </v-layout>
</template>

<script>
import axios from 'axios'
import { authComputed } from '../helpers'
import formatters from '../mixins/formattersLib'

export default {
   name: 'Aranceles',
   mixins: [formatters],

   data: () => ({
      // Variables
      dialogCreateEdit: false,
      editedIndex: -1,
      headers: [
         { text: 'Código', value: 'codigo', class: 'titulo' },
         { text: 'Nombre', value: 'nombre', class: 'titulo', width: '350px' },
         { text: 'Precio', value: 'precio', class: 'titulo' },
         {
            text: 'Comodin',
            value: 'comodin',
            class: 'titulo'
         },
         {
            text: 'Público',
            value: 'publico',
            class: 'titulo',
            align: 'center'
         },
         {
            text: 'Aplica beca',
            value: 'aplicaBeca',
            class: 'titulo',
            align: 'center'
         },
         {
            text: 'Por cantidad',
            value: 'porCantidad',
            class: 'titulo',
            align: 'center'
         },
         {
            text: 'Requiere facultad',
            value: 'requiereFacultad',
            class: 'titulo',
            align: 'center'
         },
         {
            text: 'Opciones',
            value: 'opciones',
            align: 'right',
            sortable: false,
            class: 'titulo'
         }
      ],

      // Variables de formularios
      search: '',
      pagination: {},
      result: [],
      aranceles: [],

      validAranceles: true,

      // Propiedades aranceles
      alumnoArancelPeriodoId: '',
      codigo: '',
      nombre: '',
      descripcion: '',
      precio: '',
      aplicaBeca: false,
      porCantidad: false,
      requiereFacultad: false,
      selectPublico: false,
      cmbPublico: [
         {
            id: null,
            descripcion: 'Ambos'
         },
         {
            id: true,
            descripcion: 'Externos'
         },
         {
            id: false,
            descripcion: 'Alumnos'
         }
      ],
      comodin: '',

      // Si la última tecla fue de borrado; ver el watch de `codigo`.
      borrandoCodigo: false,

      // Reglas de validacion de formularios
      rulesNombre: [(v) => !!v || 'Ingrese un nombre'],
      rulesPrecio: [(v) => !!v || 'Ingrese un precio'],
      rulesDescripcion: [(v) => !!v || 'Ingrese una descripción']
   }),
   computed: {
      ...authComputed,
      // Titulo de dialog
      formTitle() {
         return this.editedIndex === -1 ? 'Nuevo arancel' : 'Editar arancel'
      },
      /**
       * Reglas del código. Van acá y no en data() porque la segunda necesita
       * consultar la lista de aranceles ya cargada, y data() no tiene `this`.
       */
      rulesCodigo() {
         return [
            (v) => !!v || 'Ingrese un código',
            // En edición el campo está bloqueado y su código es, por supuesto,
            // uno que ya existe: la regla solo aplica al crear.
            (v) =>
               this.editedIndex !== -1 ||
               !this.codigoYaExiste(v) ||
               'Ese código ya existe'
         ]
      },
      /**
       * Base y sufijo de lo escrito, o null si todavía no es un código con el
       * formato NN-NNN-N. El sufijo es obligatorio: sin él no hay familia que
       * consultar, y es la familia lo que da la sugerencia.
       */
      partesCodigo() {
         const m = (this.codigo || '').trim().match(/^(\d{2}-\d{3})-(\d+)$/)

         return m ? { base: m[1], sufijo: m[2] } : null
      },
      /**
       * Código que se ofrece para lo escrito, o '' si no hay nada que ofrecer.
       *
       * El sufijo escrito acota la búsqueda a esa familia: con el 4 se mira el
       * 4x. Si la familia está vacía el sufijo tecleado ya sirve y no hay nada
       * que sugerir; tampoco lo hay si lo escrito ES la sugerencia.
       */
      sugerenciaCodigo() {
         if (this.editedIndex !== -1) return ''

         const partes = this.partesCodigo
         if (!partes) return ''

         const base = partes.base
         const sufijo = partes.sufijo
         if (!this.sufijosDe(base, sufijo).length) return ''

         const sugerido = `${base}-${this.siguienteSufijo(base, sufijo)}`
         return sugerido === (this.codigo || '').trim() ? '' : sugerido
      },
      /**
       * Texto de ayuda bajo el campo: indica el formato mientras no haya uno
       * válido, y una vez lo hay informa de cómo va esa familia de códigos.
       */
      hintCodigo() {
         if (this.editedIndex !== -1) return ''

         const partes = this.partesCodigo
         if (!partes)
            return 'Escribe el código con el formato NN-NNN-N, por ejemplo 03-015-4'

         const base = partes.base
         const sufijo = partes.sufijo

         // Nadie más en esa familia: el sufijo tecleado sirve tal cual.
         const familia = this.sufijosDe(base, sufijo)
         if (!familia.length) return `El código ${base}-${sufijo} está libre`

         const ultimo = Math.max.apply(null, familia)
         const siguiente = this.siguienteSufijo(base, sufijo)
         return `El último registrado es ${base}-${ultimo}. Se sugiere el ${base}-${siguiente}`
      },
      // Descripcion de publico
      publicoDescripcion() {
         return this.cmbPublico.find((obj) => {
            return obj.id === this.selectPublico
         }).descripcion
      }
   },
   watch: {
      /**
       * Completa el código mientras se escribe, en cuanto hay un NN-NNN-N.
       *
       * Lo completado se deja SELECCIONADO, que es lo que hace usable escribir
       * el sufijo: al teclear el 4 el campo muestra 03-015-46 con el 6
       * seleccionado, y si se sigue con el 5 ese 6 se reemplaza y queda
       * 03-015-45. Rellenando sin seleccionar, el dígito insertado se quedaba
       * fijo y lo siguiente se le pegaba: salía 03-015-14, o 03-015-101.
       *
       * Solo se completa si la sugerencia EXTIENDE lo escrito. Si no lo
       * extiende (tecleado el 44, sugerido el 46) se respeta lo escrito y lo
       * dice el hint, en lugar de reescribirle los dígitos al usuario.
       */
      codigo(valor) {
         if (this.editedIndex !== -1) return
         // Borrar tiene que poder deshacer lo completado; sin esto el campo se
         // rellenaba solo al retroceder y quedaba trabado.
         if (this.borrandoCodigo) return

         // `sugerenciaCodigo` ya viene vacía si lo escrito no es un NN-NNN-N,
         // así que no hace falta volver a comprobar el formato acá.
         const escrito = (valor || '').trim()
         const sugerido = this.sugerenciaCodigo
         if (!sugerido || !sugerido.startsWith(escrito)) return

         this.codigo = sugerido
         this.$nextTick(() => {
            const campo = this.$refs.txtCodigo
            const input = campo && campo.$refs.input
            if (input) input.setSelectionRange(escrito.length, sugerido.length)
         })
      }
   },
   created() {
      if (this.permController(15, 'ver')) {
         this.listarAranceles()
      } else {
         this.$router.push({ name: 'inicio' })
      }
   },
   methods: {
      /**
       * Anota si la tecla fue de borrado, para que el watch de `codigo` no
       * vuelva a completar justo lo que se acaba de borrar.
       */
      registrarTeclaCodigo(evento) {
         this.borrandoCodigo =
            evento.key === 'Backspace' || evento.key === 'Delete'
      },
      /**
       * Sufijos ya dados de alta para una base como "03-015". Con `prefijo`
       * devuelve solo los de esa familia.
       *
       * El prefijo se compara como TEXTO y no como número: escribir el 4 busca
       * el 4 y también el 40, el 45..., que es como está numerado el catálogo.
       * Comparado como número, el 4 solo encontraría al 4.
       */
      sufijosDe(base, prefijo) {
         // La base se escapa antes de armar la expresión: lleva guiones, que en
         // otra posición podrían alterar el patrón.
         const patron = new RegExp(
            '^' + base.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '-(\\d+)$'
         )

         const sufijos = []
         this.aranceles.forEach((a) => {
            const m = (a.codigo || '').trim().match(patron)
            if (!m) return
            if (prefijo && !m[1].startsWith(prefijo)) return
            sufijos.push(Number(m[1]))
         })

         return sufijos
      },
      /**
       * Sufijo que sigue al último dado de alta, dentro de la familia `prefijo`
       * si se indica: con 03-015-45 ya creado, el prefijo 4 sugiere el 46.
       *
       * Continúa la numeración en lugar de rellenar huecos: un código dado de
       * baja sigue apareciendo en pagos e históricos, y reutilizar su número
       * mezclaría dos aranceles distintos bajo el mismo código.
       *
       * Si la familia está vacía, el propio prefijo es el candidato (el 9 sin
       * ningún 9x sugiere el 9); y si no hay prefijo, se arranca en 1.
       */
      siguienteSufijo(base, prefijo) {
         const sufijos = this.sufijosDe(base, prefijo)
         let candidato = sufijos.length
            ? Math.max.apply(null, sufijos) + 1
            : Number(prefijo) || 1

         // El prefijo acota la búsqueda a una familia, pero el número que sigue
         // puede estar tomado por otra: después del 03-015-44 viene el 45, que
         // quizá ya exista. Se avanza hasta uno libre de verdad, para no
         // sugerir un código que el propio formulario va a rechazar.
         while (this.codigoYaExiste(`${base}-${candidato}`)) candidato++

         return candidato
      },
      /**
       * Si el código ya está dado de alta. Compara sin espacios y sin distinguir
       * mayúsculas, porque el código se escribe a mano.
       */
      codigoYaExiste(valor) {
         const clave = (valor || '').trim().toUpperCase()
         if (!clave) return false

         return this.aranceles.some(
            (a) => (a.codigo || '').trim().toUpperCase() === clave
         )
      },
      // Select an item
      assingItem(item) {
         this.codigo = item.codigo
         this.nombre = item.nombre
         this.descripcion = item.descripcion
         this.precio = item.precio
         this.aplicaBeca = item.aplicaBeca
         this.porCantidad = item.porCantidad
         this.requiereFacultad = item.requiereFacultad
         this.comodin = item.comodin
         this.selectPublico = item.publico
      },
      // Autoseleccionar la busqueda al cambiar filtro de busquedad
      focusBusqueda() {
         this.$refs.txtBusqueda.focus()
      },
      // Popular el datatable
      listarAranceles() {
         // Obteniendo aranceles
         axios
            .get('api/Arancel')
            .then((response) => {
               this.aranceles = response.data
            })
            .catch((error) => {
               console.log(error)
            })
      },
      // Si no cargaron bien las aranceles en el datatable se puede resetear
      reset() {
         this.listarAranceles()
      },

      // Cargando informacion del item a editar
      editItem(item) {
         // El índice se marca ANTES de cargar los datos: al asignar el código
         // se dispara su watch, y sin la marca puesta lo tomaría por uno que se
         // está escribiendo y lo completaría con otro sufijo.
         this.editedIndex = 1
         this.assingItem(item)
         this.dialogCreateEdit = true
         if (document.activeElement instanceof HTMLElement)
            document.activeElement.blur()
      },
      // Cerrar ventana de dialogo
      close() {
         this.dialogCreateEdit = false
         this.clear()
         setTimeout(() => {
            this.editedIndex = -1
         }, 300)
      },
      // Guardar/Actulizar aranceles
      save() {
         if (this.$refs.formAranceles.validate()) {
            if (this.editedIndex > -1) {
               // Codigo para actualizar/editar
               axios
                  .put('api/Arancel/codigo?codigo=' + this.codigo, {
                     codigo: this.codigo,
                     nombre: this.nombre,
                     descripcion: this.descripcion,
                     precio: this.precio,
                     aplicaBeca: this.aplicaBeca,
                     publico: this.selectPublico,
                     porCantidad: this.porCantidad,
                     requiereFacultad: this.requiereFacultad,
                     comodin: this.comodin
                  })
                  .then(() => {
                     this.listarAranceles()
                     this.close()
                     this.$store.dispatch('showSnack', {
                        message: 'Arancel editado exitosamente!',
                        color: 'snackSuccess'
                     })
                  })
                  .catch((error) => {
                     if (error.response.status == 304) {
                        this.$store.dispatch('showSnack', {
                           message: 'Sin cambios.',
                           color: 'snackInfo'
                        })
                     } else {
                        this.$store.dispatch('showSnack', {
                           message: 'Algo ha ido mal...',
                           color: 'snackError'
                        })
                     }
                     this.close()
                  })
            } else {
               // Codigo para guardar
               axios
                  .post('api/Arancel', {
                     codigo: this.codigo,
                     nombre: this.nombre,
                     descripcion: this.descripcion,
                     precio: this.precio,
                     aplicaBeca: this.aplicaBeca,
                     publico: this.selectPublico,
                     porCantidad: this.porCantidad,
                     requiereFacultad: this.requiereFacultad,
                     comodin: this.comodin
                  })
                  .then(() => {
                     this.listarAranceles()
                     this.close()
                     this.$store.dispatch('showSnack', {
                        message: 'Arancel agregado exitosamente!',
                        color: 'snackSuccess'
                     })
                  })
                  .catch(() => {
                     this.$store.dispatch('showSnack', {
                        message:
                           'No se pudo crear el arancel. Revisar si el código ingresado no esta en uso.',
                        color: 'snackError'
                     })
                  })
            }
         }
      },

      // Limpiar formularios y componentes
      clear() {
         try {
            this.$refs.formAranceles.resetValidation()
         } catch (error) {
            //Do nothing
         }
         this.borrandoCodigo = false
         this.codigo = ''
         this.nombre = ''
         this.descripcion = ''
         this.precio = ''
         this.aplicaBeca = false
         this.porCantidad = false
         this.requiereFacultad = false
         this.comodin = ''
         this.selectPublico = false
      },
      nuevoArancel() {
         this.dialogCreateEdit = true
      }
   }
}
</script>
